<template>
  <div>
  <!-- Image select modal -->
    <div class="row align-right">
      <q-btn
        icon="close"
        @click="close()"
        />
    </div>
    <div style="height: 75vh">
      <div class="row q-pa-md">
        <div class="col-7 q-pa-md">
          <div class="row q-mb-sm align-right">
          <!-- Fileinput for buttonUpload (hidden) -->
          <q-btn
            class="capitalize ctrl-button right q-ml-md"
            :disable="!allowedToDrop"
            :class="{ 'disabled-btn': !allowedToDrop }"
            :color="!apiUrl || apiUrl === 'library' ? 'grey-5' : 'ctrl-turquoise'"
            :disabled="!apiUrl || apiUrl === 'library'"
            :label="getString('module.library.uploader.btn')"
            icon-right="create_new_folder"
            @click="publishLibraryEvent('library:upload')"
          />
          <q-btn
            class="capitalize ctrl-button right q-ml-md"
            color="ctrl-turquoise"
            :label="getString('module.library.addFolder')"
            icon-right="create_new_folder"
            @click="publishLibraryEvent('library:new-folder')"
          />
          </div>
          <library-table :guid="guid" :fileType="fileType" :useStoreFilters="false" :extension="extension" :readonly="true" spacing="50vh"/>
        </div>
        <div class="col-5 q-pa-md">
          <div>
            <file-preview :fileType="fileType" :guid="guid"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LibraryTable from '@/components/library/LibraryTable.vue';
import FilePreview from '@/components/library/ImagePreview.vue';
import EventBus from '@/event-bus';

// Helpers
import getString from '@/helpers/GetStrings';

export default {
  components: {
    LibraryTable,
    FilePreview,
  },
  data() {
    return {
      apiUrl: '',
    };
  },
  methods: {
    getString,

    publishLibraryEvent(eventName) {
      EventBus.$emit(eventName);
    },

    close() {
      // Broadcast the image modal close event.
      EventBus.$emit('file-select-close');
    },

    allowedToDrop() {
      return this.apiUrl !== '/library';
    },
  },

  props: {
    guid: {
      type: String,
      required: true,
    },

    // Limit on filetype. image or file
    fileType: {
      type: String,
      default: null,
    },

    // Further limit on file extension. eg (pdf, jpg)
    extension: {
      type: String,
      default: null,
    },
  },

  mounted() {
    EventBus.$on('library-table:fetch-content', (data) => {
      this.activeDir = data;
      // Cut out string 'api' for the right api call
      const url = data.location.replace('api', '');
      this.apiUrl = url;
    });
  },

  destroyed() {
    EventBus.$off('library-table:fetch-content');
  },
};
</script>

<style lang="stylus">
.align-right
  display flex
  justify-content flex-end
</style>
